module.exports = __webpack_public_path__ + "img/icon-bracket.00759bbe.svg";